import React, { useState, useEffect } from "react";
import { 
  Dialog, DialogTitle, DialogContent, Box, Typography, 
  IconButton, TextField, Select, MenuItem, FormControl, InputLabel, 
  InputAdornment, Divider, Paper, Alert, Tooltip, CircularProgress, Button, Chip
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'; 
import CloudSyncIcon from '@mui/icons-material/CloudSync'; 
import EditIcon from '@mui/icons-material/Edit'; 
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'; 
import { usePriceContext } from '../context/PriceContext';

const PosCihaziKutusu = ({ sube, forceOpen, onClose }) => {
  const { prices } = usePriceContext();
  const [open, setOpen] = useState(forceOpen || false);
  
  // Has Altın Kuru
  const [hasKur, setHasKur] = useState('');
  const [manuelMod, setManuelMod] = useState(false); 
  const [bistYukleniyor, setBistYukleniyor] = useState(false);
  const [veriTarihi, setVeriTarihi] = useState(''); 
  
  // Seçimler
  const [secilenUrun, setSecilenUrun] = useState('');
  
  // Değerler
  const [miktar, setMiktar] = useState(''); 
  const [toplamCekilecekTutar, setToplamCekilecekTutar] = useState(''); 
  
  // Sonuçlar
  const [sonuc, setSonuc] = useState(null);

  const POS_KISIMLARI = {
    'ÇEYREK ALTIN': { tip: 'katsayi', deger: 1.605, birim: 'Adet' },
    'YARIM ALTIN':  { tip: 'katsayi', deger: 3.21,  birim: 'Adet' },
    'TAM ALTIN':    { tip: 'katsayi', deger: 6.42,  birim: 'Adet' },
    '22 AYAR':      { tip: 'milyem',  deger: 0.916, birim: 'Gr' },
    '24 AYAR':      { tip: 'milyem',  deger: 0.995, birim: 'Gr' },
    '14 AYAR':      { tip: 'milyem',  deger: 0.585, birim: 'Gr' },
    '8 AYAR':       { tip: 'milyem',  deger: 0.333, birim: 'Gr' }
  };

  const noSpinStyle = {
    '& input[type=number]': { MozAppearance: 'textfield' },
    '& input[type=number]::-webkit-outer-spin-button': { WebkitAppearance: 'none', margin: 0 },
    '& input[type=number]::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 },
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose(); 
  };

  // --- ÖNCEKİ İŞ GÜNÜ HESAPLAMA (Mantık: Bugün Ptesi ise Cuma'yı getir) ---
  const getPreviousBusinessDay = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0: Pazar, 1: Ptesi, ... 6: Ctesi
    let targetDate = new Date(today);

    if (dayOfWeek === 0) { // Pazar ise -> Cuma (2 gün geri)
        targetDate.setDate(today.getDate() - 2);
    } else if (dayOfWeek === 1) { // Pazartesi ise -> Cuma (3 gün geri)
        targetDate.setDate(today.getDate() - 3);
    } else if (dayOfWeek === 6) { // Cumartesi ise -> Cuma (1 gün geri)
        targetDate.setDate(today.getDate() - 1);
    } else { // Salı, Çarş, Perş, Cuma -> Bir önceki gün (1 gün geri)
        targetDate.setDate(today.getDate() - 1);
    }
    
    // Format: DD.MM.YYYY
    return targetDate.toLocaleDateString('tr-TR');
  };

  // --- GÜÇLENDİRİLMİŞ BIST VERİ ÇEKME ---
  const fetchBistData = async () => {
    setBistYukleniyor(true);
    setVeriTarihi(''); 
    
    // Hesaplanan tarihi al (Örn: Bugün Ptesi ise Cuma'nın tarihini alır)
    const hesaplananGecmisTarih = getPreviousBusinessDay();

    const targetUrl = 'https://www.borsaistanbul.com/referans-fiyatlari.php?op=generateReferansFiyatlariXML';
    const proxies = [
      { url: `https://api.allorigins.win/get?url=${encodeURIComponent(targetUrl)}`, type: 'json' },
      { url: `https://corsproxy.io/?${encodeURIComponent(targetUrl)}`, type: 'text' }
    ];

    let basarili = false;

    for (const proxy of proxies) {
      if (basarili) break;

      try {
        const response = await fetch(proxy.url, { cache: 'no-store' });
        if (!response.ok) throw new Error("Bağlantı hatası");

        let xmlText = '';
        if (proxy.type === 'json') {
          const json = await response.json();
          xmlText = json.contents;
        } else {
          xmlText = await response.text();
        }

        if (!xmlText) throw new Error("Boş veri");

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, "text/xml");
        
        const altinNode = xmlDoc.querySelector("altindeger");

        if (altinNode) {
            const rawPrice = altinNode.textContent; 
            const cleanPrice = rawPrice.replace(/\./g, '').replace(',', '.');
            const kgFiyati = parseFloat(cleanPrice);
            const gramFiyati = kgFiyati / 1000;

            setHasKur(gramFiyati.toFixed(2));
            
            // DÜZELTME BURADA:
            // BIST XML'inden gelen tarihi (<gun>) YAZDIRMIYORUZ.
            // Çünkü BIST o tarihi "Bugün" (Geçerlilik Tarihi) olarak verir.
            // Biz kullanıcının kafası karışmasın diye hesapladığımız "Önceki İş Günü"nü basıyoruz.
            setVeriTarihi(hesaplananGecmisTarih); 

            setManuelMod(true);
            basarili = true;
        }
      } catch (err) {
        console.warn(`Proxy denemesi başarısız:`, err);
      }
    }

    if (!basarili) {
      alert("BIST verisi şu an çekilemiyor. Lütfen manuel giriş yapınız.");
    }
    
    setBistYukleniyor(false);
  };

  // Fiyatları Çek (Otomatik / Piyasa Modu)
  useEffect(() => {
    if (!manuelMod && prices && prices.length > 0) {
      const altin = prices.find(p => p.currencyCode === "ALTINTRY" || p.currencyCode === "HAS ALTIN" || p.currencyCode === "HAS");
      let yeniKur = 0;

      if (altin && altin.sell) {
        yeniKur = parseFloat(altin.sell);
      } else {
        const xauusd = prices.find(p => p.currencyCode === "XAUUSD");
        const usdtry = prices.find(p => p.currencyCode === "USDTRY");
        if (xauusd?.sell && usdtry?.sell) {
           yeniKur = (xauusd.sell * usdtry.sell) / 31.1035;
        }
      }

      if (yeniKur > 0) {
          setHasKur(yeniKur.toFixed(2));
          setVeriTarihi(''); 
      }
    }
  }, [prices, manuelMod]);

  const handleKurChange = (e) => {
      setHasKur(e.target.value);
      setManuelMod(true);
      setVeriTarihi(''); 
  };

  useEffect(() => {
    if (!hasKur || !miktar || !toplamCekilecekTutar || !secilenUrun) {
        setSonuc(null);
        return;
    }

    const urunBilgisi = POS_KISIMLARI[secilenUrun];
    const miktarSayi = parseFloat(miktar);
    const toplamTutarSayi = parseFloat(toplamCekilecekTutar);
    const kurSayi = parseFloat(hasKur.toString().replace(',', '.'));

    let hamAltinMaliyeti = miktarSayi * urunBilgisi.deger * kurSayi;
    let iscilikTutari = toplamTutarSayi - hamAltinMaliyeti;
    let anaKisimTutari = hamAltinMaliyeti;
    let uyari = null;

    if (iscilikTutari < 0) {
        iscilikTutari = 0;
        anaKisimTutari = toplamTutarSayi;
        uyari = "DİKKAT: Girilen tutar, has maliyetinin altında!";
    }

    setSonuc({
        urunAdi: secilenUrun,
        anaKisim: anaKisimTutari,
        iscilik: iscilikTutari,
        toplam: toplamTutarSayi,
        uyari: uyari
    });

  }, [hasKur, miktar, toplamCekilecekTutar, secilenUrun]);

  const mevcutBirim = secilenUrun ? POS_KISIMLARI[secilenUrun].birim : 'Adet/Gr';

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      PaperProps={{ sx: { width: '700px', maxWidth: 'none' } }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#1b5e20', color: 'white' }}>
        <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
            <PointOfSaleIcon />
            <Typography variant="h6" fontWeight="bold">POS Fiş Sihirbazı</Typography>
        </Box>
        <IconButton onClick={handleClose} sx={{ color: 'white' }}><CloseIcon /></IconButton>
      </DialogTitle>
      
      <DialogContent dividers sx={{ p: 4, bgcolor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        
        {/* 1. SATIR: CANLI HAS KUR KUTUSU */}
        <Box sx={{ 
            width: '600px', 
            height: '64px', 
            mb: 3, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            paddingX: 2,
            gap: 1, 
            bgcolor: '#e8f5e9', 
            borderRadius: 2, 
            border: '1px solid #c8e6c9',
            boxSizing: 'border-box',
            position: 'relative' 
        }}>
            {/* ETİKET + INPUT */}
            <Box sx={{ display:'flex', alignItems:'center', gap: 2 }}>
                <Typography variant="subtitle2" fontWeight="bold" color="#2e7d32">
                    HAS KUR:
                </Typography>

                <Box sx={{ display:'flex', alignItems:'center' }}>
                    <TextField 
                        variant="standard" 
                        type="number" 
                        value={hasKur} 
                        onChange={handleKurChange}
                        InputProps={{ disableUnderline: true, style: { fontWeight: 'bold', fontSize: '1.4rem', color: '#2e7d32', textAlign:'right' } }}
                        sx={{ width: '90px', input: { textAlign: 'right' }, ...noSpinStyle }} 
                        placeholder="0.00"
                    />
                    <Typography variant="subtitle2" color="#2e7d32" sx={{ ml:0.5 }}>TL</Typography>
                </Box>

                {/* BIST TARİH GÖSTERGESİ */}
                {veriTarihi && (
                   <Tooltip title="Borsa İstanbul Kapanış Verisi Tarihi">
                       <Chip 
                         icon={<CalendarTodayIcon style={{fontSize:14}} />} 
                         label={veriTarihi} 
                         size="small" 
                         color="primary" 
                         variant="outlined"
                         sx={{ ml: 1, height: 24, fontSize: '0.75rem', fontWeight:'bold', borderColor:'#1565c0', color:'#1565c0' }}
                       />
                   </Tooltip>
                )}
            </Box>

            {/* BUTON GRUBU */}
            <Box sx={{ display:'flex', gap: 1 }}>
                
                <Button
                    variant={!manuelMod ? "contained" : "outlined"}
                    color="success"
                    size="small"
                    startIcon={<CloudSyncIcon />}
                    onClick={() => { setManuelMod(false); setVeriTarihi(''); }}
                    sx={{ textTransform: 'none', fontWeight: 'bold', fontSize: '0.75rem' }}
                >
                    Piyasa
                </Button>

                <Button
                    variant={manuelMod && !veriTarihi ? "contained" : "outlined"}
                    color="warning"
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => { setManuelMod(true); setVeriTarihi(''); }}
                    sx={{ textTransform: 'none', fontWeight: 'bold', fontSize: '0.75rem' }}
                >
                    Manuel
                </Button>

                <Tooltip title="Borsa İstanbul Kapanış Verisini Çeker (Haftasonu ise Cuma)">
                    <Button
                        variant={veriTarihi ? "contained" : "contained"} 
                        sx={{ bgcolor: '#1565c0', '&:hover': { bgcolor: '#0d47a1' }, textTransform: 'none', fontWeight: 'bold', fontSize: '0.75rem' }}
                        size="small"
                        startIcon={bistYukleniyor ? <CircularProgress size={14} color="inherit" /> : <AccountBalanceIcon />}
                        onClick={fetchBistData}
                        disabled={bistYukleniyor}
                    >
                        BIST
                    </Button>
                </Tooltip>
            </Box>
        </Box>

        {/* 2. SATIR: ÜRÜN CİNSİ -- MİKTAR */}
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl sx={{ width: '250px' }}>
                <InputLabel sx={{ lineHeight: '1em' }}>Ürün Cinsi</InputLabel>
                <Select 
                    value={secilenUrun} 
                    label="Ürün Cinsi" 
                    onChange={(e) => setSecilenUrun(e.target.value)}
                    sx={{ height: '56px' }}
                >
                    {Object.keys(POS_KISIMLARI).map(k => (
                        <MenuItem key={k} value={k}>{k}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField 
                label={secilenUrun ? `Miktar` : "Miktar"}
                type="number" 
                value={miktar}
                onChange={(e) => setMiktar(e.target.value)}
                InputProps={{ endAdornment: <InputAdornment position="end">{mevcutBirim}</InputAdornment> }}
                sx={{ width: '250px', bgcolor: 'white', '& .MuiInputBase-root': { height: '56px' }, ...noSpinStyle }}
            />
        </Box>

        {/* 3. SATIR: TUTAR */}
        <TextField 
            label="Çekilecek Toplam Tutar" 
            type="number" 
            value={toplamCekilecekTutar}
            onChange={(e) => setToplamCekilecekTutar(e.target.value)}
            InputProps={{ endAdornment: <InputAdornment position="end">TL</InputAdornment> }}
            sx={{ 
                width: '350px', 
                bgcolor: '#fffde7', 
                '& .MuiInputBase-root': { height: '56px', fontWeight: 'bold' },
                ...noSpinStyle 
            }}
        />

        <Divider sx={{ my: 3, width: '100%' }} />

        {/* SONUÇ EKRANI */}
        {sonuc && (
            <Paper elevation={4} sx={{ width: '350px', p: 0, bgcolor: 'white', border: '1px solid #ddd', fontFamily: 'monospace' }}>
                <Box sx={{ bgcolor: '#eee', p: 1, textAlign: 'center', borderBottom: '1px dashed #bbb' }}>
                    <Typography variant="caption" fontWeight="bold" color="#555">POS CİHAZI EKRANI</Typography>
                </Box>

                <Box sx={{ p: 2 }}>
                    {sonuc.uyari && (
                        <Alert severity="warning" sx={{ mb: 2, fontSize: '0.75rem' }}>{sonuc.uyari}</Alert>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="body1" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
                            {sonuc.urunAdi}
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
                            {sonuc.anaKisim.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: '#d32f2f' }}>
                        <Typography variant="body1" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
                            İŞÇİLİK
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
                            {sonuc.iscilik.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1, borderStyle: 'dashed' }} />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>TOPLAM</Typography>
                        <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
                            {sonuc.toplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        )}

      </DialogContent>
    </Dialog>
  );
};

export default PosCihaziKutusu;